import { render, staticRenderFns } from "./ProjectStretchGoalCard.vue?vue&type=template&id=a961a3c6"
import script from "./ProjectStretchGoalCard.vue?vue&type=script&lang=js"
export * from "./ProjectStretchGoalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports